<template>
  <anchor-modal
    v-model="display"
    width="700"
    :title="title"
    light
    header-color="white"
    :header-split="true"
  >
    <role-levels-form
      v-if="display"
      ref="form"
      @cancel="() => display = false"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import RoleLevelsForm from './RoleLevelsForm';


export default {
  name: 'AdminRoleLevelsModalForm',
  components: {
    RoleLevelsForm,
  },
  data: () => ({
    display: false,
    title: '',
  }),
  methods: {
    open(role) {
      this.display = true;
      this.title = role ? 'Edit Role Level' : 'Add New Role Level';
      this.$nextTick(() => {
        this.$refs.form.setModel(role);
      });
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
};
</script>
